import React, { useState, useEffect } from "react";
import check from "../../assets/Images/check.png";
import { clearPaymentCVVs, SessionState } from "../../redux/sessionSlice";
import { useDispatch, useSelector } from "react-redux";
import "./SubscriptionManagement.css"; // Import your CSS file for animations
import {useAsaSession,useAsaSessionPagesMutation,useIsLoading,useBackButton} from '../../services/AsaSessionServices'
import {useActiveSubscriptions,useSubscriptionsPlans,
  useRateOnUpgradePlan,useFintechLayouts,useBillingAddresses,
  useSubscriptionPaymentMutation,usePaymentMethods,
  useSubscriptionPaymentMethodUpdateMutation,useSubscriptionUpgradeMutation
  } from '../../services/AsaApiServices'

  import { useNavigate,useLocation } from "react-router-dom";

const MXWidget = () => {
  const dispatch = useDispatch();
  const {data:session}=useAsaSession()
  const layout=useFintechLayouts()
  const {data:activesubscriptions}=useActiveSubscriptions()

  const location = useLocation();
  const { state } = location;
  
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-b from-[#705AE2] to-[#705AE2]">
      
    </div>
  );
};

export default MXWidget;
